import styled from 'styled-components';
import { AllieButton } from '../../../components/Buttons/Button';

export const Card = styled.div`
  border: 1px solid var(--allie-color-neutral-20);
  border-radius: var(--allie-radius-md);
  background-color: white;
  width: 100%;
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  border-bottom: 1px solid var(--allie-color-neutral-20);
  padding: var(--allie-spacing-lg);
`;

export const DefaultContentContainer = styled.div`
  padding: var(--allie-spacing-lg);
  padding-bottom: 0;
`;

export const ExpandedContentContainer = styled.div`
  padding: var(--allie-spacing-lg);
  padding-top: 0;
`;

export const ExpandButton = styled(AllieButton)`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--allie-color-neutral-20);
  --padding-top: var(--allie-spacing-md) !important;
  --padding-bottom: var(--allie-spacing-md) !important;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--allie-spacing-md);
`;
